import Pusher from "pusher-js";

type PusherSingleton = {
  instance: Pusher | null;
  credentials: { token: string; store_id: string } | null;
};

const PUSHER_KEY = "__KOINZ_PUSHER_SINGLETON__";

const getSingleton = (): PusherSingleton => {
  if (typeof window === "undefined") {
    return { instance: null, credentials: null };
  }
  if (!(window as any)[PUSHER_KEY]) {
    (window as any)[PUSHER_KEY] = { instance: null, credentials: null };
  }
  return (window as any)[PUSHER_KEY];
};

const createPusher = (token: string, store_id: string): Pusher => {
  return new Pusher(process.env.REACT_APP_PUSHER_API_KEY!, {
    authEndpoint: `${process.env.REACT_APP_ENDPOINT}/api/pusher/manager/auth`,
    auth: {
      headers: { token },
      params: { store_id },
    },
    cluster: "eu",
    forceTLS: true,
  });
};

export const pusher = (token: string, store_id: string): Pusher | null => {
  if (typeof window === "undefined") {
    return null;
  }

  const state = getSingleton();

  if (
    state.instance &&
    state.credentials?.token === token &&
    state.credentials?.store_id === store_id
  ) {
    return state.instance;
  }

  if (state.instance) {
    state.instance.disconnect();
    state.instance = null;
    state.credentials = null;
  }

  if (!token || !store_id) {
    return null;
  }

  state.instance = createPusher(token, store_id);
  state.credentials = { token, store_id };

  state.instance.connection.bind("error", (err) => {
    console.error("Pusher connection error:", err);
  });

  return state.instance;
};
